<template>
    <div class="row">
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader">
      </loading>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Product</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <div class="form-inline ml-auto">
                <div class="button-group">
                  <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addProduct">
                    <i class="fa fa-plus" aria-hidden="true"></i> New
                  </button>
                  <div class="btn-group">
                    <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshProduct">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                    <button class="btn btn-success btn-sm btn-soft-outline-primary dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
                    <div class="dropdown-menu" aria-labelledby="action">
                      <!-- <a class="dropdown-item" href="javascript:void(0)" @click="setCOGS">Set COGS</a> -->
                      <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalProductCostSync" data-backdrop="static" data-keyboard="false" >Sync By date</a>
                    </div>
                  </div>
                  <div class="btn-group">
                    <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                      <i class="fa fa-filter" aria-hidden="true"></i>
                        Filter
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu p-2">
                      <span>Etc</span>
                      <div class="dropdown-divider"></div>
                      <li>
                        <a href="javascript:void(0)" class="small" tabIndex="-1">
                          <input type="checkbox" value="true" v-model="filterAccount" />&nbsp; Diff Persediaan
                        </a>
                      </li>
                      <span>Category:</span>
                      <div class="dropdown-divider"></div>
                      <li v-for="ct in categoryList" :key="ct.id">
                        <a href="#" class="small" tabIndex="-1">
                          <input type="checkbox" :value="ct.id" v-model="filterCategory"/>&nbsp; {{ ct.name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>
                  <span class="mr-1">
                    Total rows: <b>{{ rowsTotal }}</b>
                  </span>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                </div>
                <span class="mr-1">
                  page:
                  <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                  </select>
                  / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                <i class="fa fa-angle-left" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="button-group">
                  <button type="button" class="btn btn-sm btn-hard-primary" @click="viewChange('table')" v-if="view === 'table'"><i class="fa fa-table" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-sm btn-hard-outline-primary" @click="viewChange('table')" v-else><i class="fa fa-table" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-sm btn-hard-primary" @click="viewChange('grid')" v-if="view === 'grid'"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-sm btn-hard-outline-primary" @click="viewChange('grid')" v-else><i class="fa fa-th-large" aria-hidden="true"></i></button>
                </div>
              </div>
              <div v-if="view === 'table'">
                <table class="table table-item mb-0 table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th>
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="13" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                        <tr v-for="(u, index) in filterData" v-bind:key="u.id" style="cursor: pointer" :class="index === idx ? 'trcolor' : null">
                          <td>
                            <label class="form-checkbox">
                              <input type="checkbox" :value="u.id" v-model="selected" class="custom--checkbox">
                              <i class="form-icon"></i>
                            </label>
                          </td>
                          <td @click="editProduct(u.id, index)"><b>{{ u.product_no }}</b></td>
                          <td @click="editProduct(u.id, index)">{{ u.product_name }}</td>
                          <td @click="editProduct(u.id, index)">{{ u.category }}</td>
                          <td @click="editProduct(u.id, index)">{{ u.type }}</td>
                          <td @click="editProduct(u.id, index)">{{ u.uom_id }}</td>
                          <td @click="editProduct(u.id, index)">{{ u.barcode }}</td>
                          <td @click="editProduct(u.id, index)">
                            <span v-if="u.canBarcode === true"><i class="fa fa-check text-secondary"></i></span>
                          </td>
                          <td @click="editProduct(u.id, index)">
                            <span v-if="u.is_variant === true"><i class="fa fa-check text-secondary"></i></span>
                          </td>
                          <td @click="editProduct(u.id, index)">
                            <span v-if="u.active" style="color: green;"><i class="fa fa-check"></i></span>
                          </td>
                          <td>{{ u.account_count }}</td>
                          <td>{{ u.type_code_persediaan }}</td>
                          <td>
                            <span v-if="u.account_code_persediaan !== u.type_code_persediaan" class="badge badge-danger">{{ u.account_code_persediaan }}</span>
                            <span v-else>{{ u.account_code_persediaan }}</span>
                          </td>
                        </tr>
                    </tbody>
                </table>
              </div>
              <div v-else-if="view === 'grid'" class="mt-3">
                <div class="row">
                  <div class="col-md-4" v-for="(i, index) in filterData" :key="i.id">
                    <div class="card" style="border: 1px solid #ccc; cursor: pointer;" @click="editProduct(i.id, index)">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-4 col-sm-4 col-md-4">
                            <img :src="`${publicPath}asset/img/product.png`" alt="" v-if="i.photo === null">
                            <img :src="i.photo" v-else/>
                          </div>
                          <div class="col-8 col-sm-8 col-md-8">
                            <h5 class="text-primary">{{ i.product_name }}</h5>
                            <h6 class="text-primary">{{ i.product_no }} </h6>
                            <ul>
                              <li>Category: <b>{{ i.category }}</b></li>
                              <li>Type: {{ i.type_id }}</li>
                              <li>Price: Rp. <span class="text-secondary">{{ i.price | currency }}</span></li>
                              <li>Qty: <span class="text-secondary">0.0 {{ i.uom_id }}</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProductListModal @getSyncData="getSyncData"/>
      <!-- <pre>{{ filterCategory }}</pre> -->
      <!-- <pre>{{ filterData }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { productUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ProductListModal from '@/components/product/ProductListModal.vue'

export default {
  name: 'ProductList',
  props: ['scroll', 'idx'],
  components: {
    Loading,
    ProductListModal
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      dateNow: new Date(),
      view: 'table',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#6ED861',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      filterCategory: [],
      filterType: [],
      filterAccount: false,
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Category',
        prop: 'category'
      }, {
        name: 'Type',
        prop: 'type_id'
      }, {
        name: 'UoM',
        prop: 'uom_id'
      }, {
        name: 'Internal Code',
        prop: 'barcode'
      }, {
        name: 'Serial Number',
        prop: 'canBarcode'
      }, {
        name: 'Variant',
        prop: 'is_variant'
      }, {
        name: 'Active',
        prop: 'active'
      }, {
        name: 'Accounts',
        prop: 'account_count'
      }, {
        name: 'Account Persediaan',
        prop: 'account_code_persediaan'
      }, {
        name: 'Type Persediaan',
        prop: 'type_code_persediaan'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshProduct()
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      rowsTable: state => state.data.rowsTable,
      categoryList: state => state.products.productCategoryList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterAccount === true) {
          if (d.account_code_persediaan !== d.type_code_persediaan) {
            return d
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async getSyncData (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      const array = this.selected

      const promises = array.map(id => {
        const detail = this.dataRaw.find(d => d.id === id)
        const data = {
          date: value.date,
          product_no: detail.product_no,
          type: 'all',
          company_no: value.company_no
        }
        console.log(data)
        return axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            return { success: true, message: response.data.message, product: detail.product_no }
          })
          .catch(error => {
            console.log(error.response?.data?.message)
            return { success: false, message: error.response?.data?.message || error.message, product: detail.product_no }
          })
      })

      try {
        const results = await Promise.all(promises)
        const failures = results.filter(r => !r.success)
        const successes = results.filter(r => r.success)

        this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false

        if (failures.length > 0) {
          const failedProducts = failures.map(f => `${f.product}: ${f.message}`).join('\n')
          await this.$swal('Partial Success', `${successes.length} succeeded, ${failures.length} failed:\n${failedProducts}`, 'warning')
        } else {
          await this.$swal('Success', `All ${successes.length} products synced successfully`, 'success')
        }
      } catch (error) {
        this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Error', 'An unexpected error occurred during sync', 'error')
      }
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        const detail = this.dataRaw.find(d => d.id === array[i])
        var data = {
          date: '2022-04-01',
          product_no: detail.product_no,
          type: 'all',
          company_no: detail.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response.data.message)
            this.$swal('Error', error.response.data.message + '[' + detail.product_no + ']', 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    viewChange: function (v) {
      this.view = v
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editProduct (id, index) {
      this.loader.isLoading = true
      axios.get(productUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var data = {
            data: response.data.data,
            index: index
          }
          this.$emit('editProduct', data)
          this.loader.isLoading = false
        })
        .catch(error => {
          this.loader.isLoading = false
          console.log(error.response)
          this.$swal(
            'Error!!!',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    addProduct () {
      this.$emit('newProduct', true)
    },
    refreshProduct () {
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      var company = auth.user.company_no
      console.log(company)
      this.$Progress.start()
      this.loader.isLoading = true
      console.log(productUrl)
      axios.get(productUrl, { headers: getHeader(), timeout: 600000 })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          this.loader.isLoading = false
          this.$Progress.finish()
          console.log(error)
          throw error
        })
    }
  }
}
</script>
